import { api } from './client.js';

export interface Subtask {
  id: string;
  title: string;
  done: boolean;
  order: number;
}

export interface Task {
  taskId: string;
  title: string;
  description: string | null;
  projectId: string;
  dueDate: string | null;
  rrule: string | null;
  subtasks: Subtask[];
  createdAt: string;
}

export type View = 'today' | 'week' | 'nodate' | 'project' | 'range' | 'all';

export interface ListTasksOpts {
  projectId?: string;
  from?: string;
  to?: string;
}

export async function listTasks(
  view: View,
  opts: ListTasksOpts = {},
  init: RequestInit = {}
): Promise<Task[]> {
  const qs = new URLSearchParams({ view });
  if (opts.projectId) qs.set('projectId', opts.projectId);
  if (opts.from) qs.set('from', opts.from);
  if (opts.to) qs.set('to', opts.to);
  const r = await api<{ tasks: Task[] }>(`/tasks?${qs}`, init);
  return r.tasks;
}

export async function createTask(input: {
  title: string;
  projectId: string;
  description?: string | null;
  dueDate?: string | null;
  rrule?: string | null;
  subtasks?: Array<{ title: string }>;
}): Promise<Task> {
  const r = await api<{ task: Task }>('/tasks', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.task;
}

export async function updateTask(tid: string, patch: Partial<Task>): Promise<Task> {
  const r = await api<{ task: Task }>(`/tasks/${tid}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.task;
}

export async function rescheduleTask(
  tid: string,
  dueDate: string | null
): Promise<Task> {
  const r = await api<{ task: Task }>(`/tasks/${tid}/reschedule`, {
    method: 'PATCH',
    body: JSON.stringify({ dueDate }),
  });
  return r.task;
}

export async function completeTask(tid: string): Promise<Task | null> {
  const r = await api<{ task: Task | null }>(`/tasks/${tid}/complete`, {
    method: 'POST',
  });
  return r.task;
}

export async function deleteTask(tid: string): Promise<void> {
  await api<void>(`/tasks/${tid}`, { method: 'DELETE' });
}
